import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isDev: false,
        navIndex: 0,
        business: '',
        name: 'tiktok',
        user: '',
        code: '',
        pre: '',
        codeLen: '',
        dataBindCode: null,
        queryDataBindProductNumber: "",
        RatailOutRepository: null,
        dataBindConfig: {
            selectProduct: '选择产品',
            selectProductNumber: '',
            dataBindType: "2", // 2-二级 3-三级
            dataBindCodeType: "大小", // 1-大小码 2-中小码
            packRateMid: null,
            packRateSmall: null,
        },
        inRepositoryData: null,
        outRepositoryData: null,
        backRepositoryData: null
    },
    mutations: {
        setNavIndex(state, data) {
            state.navIndex = data
        },
        setName(state, data) {
            state.name = data
        },
        setBusiness(state, data) {
            state.business = data
        },
        setUser(state, data) {
            state.user = data
        },
        setScanCode(state, data) {
            state.code = data
        },
        setPre(state, data) {
            state.pre = data
        },
        setDataBindCode(state, data) {
            state.dataBindCode = data
        },
        setDataBindConfig(state, data) {
            state.dataBindConfig = data
        },
        setCodeLen(state, data) {
            state.codeLen = data
        },
        setInRepositoryData(state, data) {
            state.inRepositoryData = data
        },
        setOutRepositoryData(state, data) {
            state.outRepositoryData = data
        },
        setbackRepositoryData(state, data) {
            state.backRepositoryData = data
        },

        setQueryDataBindProductNumber(state, data) {
            state.queryDataBindProductNumber = data
        },
        setRatailOutRepository(state, data) {
            state.RatailOutRepository = data
        },
    },
    actions: {},
    plugins: [createPersistedState()]
})
